import React, { useContext, useState } from 'react';
import moment from 'moment';
import view from '../../../../../assets/img/icons/view.png';
import ViewReceipt from '../shared/ViewReceipt';
import CommonRequisitionDetail from '../shared/CommonRequistionDetails';
import RequisitionContext from '../../../../../context/shared/requisitions/RequsitionContext';
import RejectRequisition from '../shared/RejectRequisition';
import ApproveRequsition from '../shared/ApproveRequsition';
import helpers from '../../../../../utils/requisition/helpers';

const ManagersRequisitionBody = () => {
  const value = useContext(RequisitionContext);
  const { managerRequisitions } = value;
  const [selectedRequisition, setSelectedRequisition] = useState(null);
  const [viewFile, setViewFile] = useState(null);
  const [activeModal, setActiveModal] = useState(null);

  const handleOpenModal = (requisition, modalType) => {
    setSelectedRequisition(requisition);
    setActiveModal(modalType);
    
    
    if (modalType === 'viewFile' && requisition.imageUpload) {
      const extension = requisition.imageUpload.split('.').pop();
      if (extension === 'document' || extension === 'pdf') {
        window.open(requisition.imageUpload, '_blank');
        return;
      }
    }
  };

  const handleCloseModal = () => {
    setActiveModal(null);
    setSelectedRequisition(null);
  };

  return (
    <>
    <tbody>
      {managerRequisitions && managerRequisitions.length > 0 ? (
        managerRequisitions.map((requisition, i) => (
          <tr key={requisition.id}>
            <td>{i + 1}</td>
            <td>
              {helpers.displayCurrency(requisition.currency)}
              {requisition.amount_in_digits}
            </td>
            <td>{requisition.amount_in_words}</td>
            <td>{requisition.account_approval}</td>
            <td>{requisition.manager_approval}</td>
            <td>{requisition.ceo_or_coo_approval}</td>
            <td>{requisition.in_favour_of}</td>
            <td>{requisition.requires_c_level_approval === false ? 'False' : 'True'}</td>
            <td>{requisition.requires_ceo_or_coo_approval === false ? 'False' : 'True'}</td>
            <td className="text-nowrap">
              {requisition.created_at ? moment(requisition.created_at).format('DD-MM-YYYY') : 'N/A'}
            </td>
            <td>{requisition.purpose}</td>
            
            
            <td>
              <button
                className="btn btn-green"
                onClick={() => handleOpenModal(requisition, 'approve')}
              >
                Approve
              </button>
            </td>
            <td>
              <button
                className="btn btn-danger"
                onClick={() => handleOpenModal(requisition, 'reject')}
              >
                Reject
              </button>
            </td>
            
            
            <td>
              <button
                onClick={() => handleOpenModal(requisition, 'viewFile')}
                style={{ border: '0', backgroundColor: 'white' }}
              >
                <span className="view2">
                  <img src={view} alt="view" title="View" />
                </span>
              </button>
            </td>
            
            <td>
              <div 
                style={{width: '100%', fontSize: '12px'}}
                className={`badge badge-${
                  requisition.account_approval === 'approved' ? 'success' : 'secondary'
                } text-uppercase`}
              >
                {requisition.account_approval === 'approved' ? 'Paid' : 'UnPaid'}
              </div>
            </td>
            
            
            <td>
              <button
                onClick={() => handleOpenModal(requisition, 'details')}
                style={{ border: '0', backgroundColor: 'white' }}
              >
                <span className="view2">
                  <img src={view} alt="view" title="View" />
                </span>
              </button>
            </td>
          </tr>
        ))
      ) : (
        <tr>
          <td colSpan="15">no requisitions</td>
        </tr>
      )}
      </tbody>
      
      
      {activeModal === 'approve' && selectedRequisition && (
        <div className="modal-root">
          <ApproveRequsition 
            requisit={selectedRequisition} 
            onClose={handleCloseModal}
          />
        </div>
      )}
      
      {activeModal === 'reject' && selectedRequisition && (
        <div className="modal-root">
          <RejectRequisition 
            requisit={selectedRequisition} 
            onClose={handleCloseModal}
          />
        </div>
      )}
      
      {activeModal === 'viewFile' && viewFile && (
        <div className="modal-root">
          <ViewReceipt 
            requisit={viewFile} 
            onClose={handleCloseModal}
          />
        </div>
      )}
      
      {activeModal === 'details' && selectedRequisition && (
        <div className="modal-root">
          <CommonRequisitionDetail 
            requisit={selectedRequisition} 
            onClose={handleCloseModal}
          />
        </div>
      )}
    </>
  );
};

export default ManagersRequisitionBody;